import { render, staticRenderFns } from "./AxTempGeneralNewDialog.vue?vue&type=template&id=5faf86aa&scoped=true"
import script from "./AxTempGeneralNewDialog.vue?vue&type=script&lang=ts"
export * from "./AxTempGeneralNewDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxTempGeneralNewDialog.vue?vue&type=style&index=0&id=5faf86aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faf86aa",
  null
  
)

export default component.exports